import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import _ from "lodash";
import * as React from "react";
import { IConfig } from "../../Config";
import DataService from "../../data/DataService";
import Loader from "../Loader";
import Modal from "../Modal";
import ManageFeeds from "./ManageFeeds";

interface IProps {
    config: IConfig;
}

interface IState {
    availableFeeds: any[];
    isLoading: boolean;
    isManageFeedsOpen: boolean;
    isManageFeedsVisible: boolean;
    selectedFeeds: any[];
}

export default class Settings extends React.Component<IProps, IState> {
    private dataService: DataService;

    public constructor(props) {
        super(props);
        this.state = {
            availableFeeds: [],
            isLoading: false,
            isManageFeedsOpen: false,
            isManageFeedsVisible: false,
            selectedFeeds: [],
        };
        this.dataService = new DataService(this.props.config);
    }

    public render() {
        return (
            <Loader isLoading={this.state.isLoading}>
                <div className="CMS_element settings">
                    <div className="CMS_title CMS_T4"><em className="fa fa-cog" aria-hidden="true"></em> Newsroom settings</div>
                    <div className="CMS_e_row">
                        <div className="CMS_title CMS_T6">
                            Feeds
                            {this.state.isManageFeedsVisible ? <a href="#"
                                style={{ float: "right" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ isManageFeedsOpen: true });
                                }}
                            >
                                Manage feeds
                            </a> : null}
                        </div>
                        <MultiSelect
                            data={this.state.availableFeeds}
                            onChange={(e) => {
                                this.selectFeedFilter(e.target.value);
                            }}
                            value={this.state.selectedFeeds}
                            textField="feedName"
                            dataItemKey="feedId"
                            filterable={true}
                        />
                    </div>
                    <div className="CMS_buttonGroup CMS_bg-R">
                        <button
                            className={`CMS_button CMS_bAction`}
                            disabled={this.state.selectedFeeds == null || this.state.selectedFeeds.length === 0 }
                            onClick={async (e) => {
                                e.preventDefault();
                                await this.updateSettings();
                            }}
                        >
                            Save
                        </button>&nbsp;
                        <button
                            className="CMS_button CMS_bCancel"
                            onClick={(e) => {
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent("onnewsroomclose"));
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
                <Modal isOpen={this.state.isManageFeedsOpen} isClosable={false}>
                    <ManageFeeds
                        config={this.props.config}
                        onClose={async () => {
                            this.setState({ isManageFeedsOpen: false });
                            await this.loadFeeds();
                        }}
                    />;
                </Modal>
            </Loader>
        );
    }

    public async componentDidMount() {
        this.setState({ isManageFeedsVisible: this.props.config.role === "superadmin" });
        await this.loadFeeds();
    }

    private async loadFeeds(page: number = 1) {
        try {
            this.setState({ isLoading: true });
            let feeds = ((await this.dataService.getAnonymousFeeds(false)).data)?.items || [];
            feeds = feeds.sort((a, b) => {
                if (a.feedName < b.feedName) { return -1; }
                if (a.feedName > b.feedName) { return 1; }
                return 0;
              });
            feeds.unshift({ feedId: "allfeeds", feedName: "All Feeds"});
            this.setState({ availableFeeds: feeds });
            const feedIds = this.props.config.feedIds || [];
            if (this.props.config.isAllFeeds) {
                this.setState({selectedFeeds : [{ feedId: "allfeeds", feedName: "All Feeds"}] });
            } else {
                const selectedFeeds = _.filter(this.state.availableFeeds, (f) => feedIds.includes(f.feedId));
                this.setState({selectedFeeds});
            }
        } finally {
            this.setState({ isLoading: false });
        }
    }

    private async updateSettings() {
        try {
            this.setState({ isLoading: true });
            const settings: any = (await this.dataService.getSettings())?.data || {};
            settings.FeedIds = this.state.selectedFeeds.map((f) => f.feedId);
            settings.IsAllFeeds = this.state.selectedFeeds[0].feedId === "allfeeds";
            if (settings.IsAllFeeds) {
                settings.FeedIds = [];
            }

            settings.selectedCategories = [];
            settings.selectedTags = [];

            await this.dataService.updateSettings(settings);
            window.dispatchEvent(new CustomEvent("onnewsroomclose"));
        } finally {
            this.setState({ isLoading: false });
        }
    }

    private selectFeedFilter(values) {
        if (values.length === 1) {
            this.setState({selectedFeeds: values });
            return;
        }

        const allFeed = _.find(values, { feedId: "allfeeds" });
        if (allFeed) {
            this.setState({selectedFeeds: [allFeed] });
        } else {
            this.setState({selectedFeeds: values });
        }
    }
};
